import { SERVICES } from "../data/site";

const Chunk = () => (
  <span className="marquee-chunk">
    {SERVICES.map((s, i) => (
      <span key={i}>
        {s.title} <span className="text-greige">&bull;</span>&nbsp;
      </span>
    ))}
  </span>
);

export const Marquee = () => (
  <div className="marquee-wrapper" data-testid="marquee-strip">
    <div className="marquee-content" aria-hidden="true">
      <Chunk />
      <Chunk />
    </div>
  </div>
);
